import { Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useNavigate } from "react-router-dom";


export default function ButtomNavigation() {
    let defaultTab = "/";
    const {pathname} = useLocation();
    if (pathname.startsWith('/search')) {
        defaultTab = "/search";
    } else if (pathname.startsWith('/notification')) {
        defaultTab = "/notification";
    } else if (pathname.startsWith('/setting')) {
        defaultTab = "/setting";
    }
    const [tab, setTab] = useState(defaultTab)
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleChangeTab = (_: any, newValue: string) => {
        setTab(newValue);
        navigate(newValue);
    }
    return (
        <Tabs
            TabIndicatorProps={{
                sx: {
                    top: 0
                }
            }}
            className="bg-primary-main"
            textColor="secondary"
            indicatorColor="secondary"
            variant="fullWidth"
            value={tab}
            onChange={handleChangeTab}>
            <Tab icon={<HomeIcon />} className={tab === '/' ? "" : "text-primary-contrastText"} value='/' label={t('home')} />
            <Tab icon={<SearchIcon />} className={tab === '/search' ? "" : "text-primary-contrastText"} value='/search/date' label={t('search')} />
            <Tab icon={<NotificationsIcon />} className={tab === '/notification' ? "" : "text-primary-contrastText"} value='/#2' label={t('notifications')} />
            <Tab icon={<SettingsIcon />} className={tab === '/setting' ? "" : "text-primary-contrastText"} value='/#1' label={t('setting')} />
        </Tabs>
    )
}
